function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { PackageCreate, PackageEdit, PackagesList } from 'modules/Packages';
import { PlansList } from 'modules/Plans';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { PermissionsEnum } from 'types/permissions/enums';
import { ORGANIZATION_TARGET } from 'types/plan';
import { CUSTOM_PLANS_MANAGEMENT_PATH, DIRECT_PLAN_CREATE_PATH, DIRECT_PLAN_EDIT_PATH, PACKAGES_LIST_PATH, PACKAGE_CREATE_PATH, PACKAGE_EDIT_PATH, PARTNER_PACKAGES_LIST_PATH, PARTNER_PACKAGE_CREATE_PATH, PARTNER_PACKAGE_EDIT_PATH, PARTNER_PLANS_LIST_PATH, PARTNER_PLAN_CREATE_PATH, PARTNER_PLAN_EDIT_PATH, PLANS_LIST_PATH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var CustomPlansManagement = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/CustomPlansManagement');
});
var PartnerPlansList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/PartnerPlansList');
});
var PartnerPackagesList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/PartnerPackagesList');
});
var CustomPlansList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/CustomPlansList');
});
var CustomPackagesList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/CustomPackagesList');
});
var PlanFormPage = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/PlanFormPage');
});
/**
 * `RouteGenerator` hands these to `<Route component={...} />`, which renders them by element type.
 * Defining them inline in the routing function would mint a fresh component type on every render of
 * `BaseRouting` — every feature-flag or account query settling, for instance — and React would
 * unmount and remount the page, silently discarding whatever the user had typed into a form.
 * They must stay at module scope so the identity survives a re-render.
 */
var DirectPlanForm = function DirectPlanForm() {
    return /*#__PURE__*/ _jsx(PlanFormPage, {
        mode: ORGANIZATION_TARGET.direct
    });
};
var PartnerPlanForm = function PartnerPlanForm() {
    return /*#__PURE__*/ _jsx(PlanFormPage, {
        mode: ORGANIZATION_TARGET.partner
    });
};
var DirectPackageCreateForm = function DirectPackageCreateForm() {
    return /*#__PURE__*/ _jsx(PackageCreate, {
        mode: ORGANIZATION_TARGET.direct
    });
};
var PartnerPackageCreateForm = function PartnerPackageCreateForm() {
    return /*#__PURE__*/ _jsx(PackageCreate, {
        mode: ORGANIZATION_TARGET.partner
    });
};
var DirectPackageEditForm = function DirectPackageEditForm() {
    return /*#__PURE__*/ _jsx(PackageEdit, {
        mode: ORGANIZATION_TARGET.direct
    });
};
var PartnerPackageEditForm = function PartnerPackageEditForm() {
    return /*#__PURE__*/ _jsx(PackageEdit, {
        mode: ORGANIZATION_TARGET.partner
    });
};
var DirectPlansListRedesigned = function DirectPlansListRedesigned() {
    return /*#__PURE__*/ _jsx(PlansList, {
        mode: ORGANIZATION_TARGET.direct
    });
};
var PartnerPlansListRedesigned = function PartnerPlansListRedesigned() {
    return /*#__PURE__*/ _jsx(PlansList, {
        mode: ORGANIZATION_TARGET.partner
    });
};
var DirectPackagesListRedesigned = function DirectPackagesListRedesigned() {
    return /*#__PURE__*/ _jsx(PackagesList, {
        mode: ORGANIZATION_TARGET.direct
    });
};
var PartnerPackagesListRedesigned = function PartnerPackagesListRedesigned() {
    return /*#__PURE__*/ _jsx(PackagesList, {
        mode: ORGANIZATION_TARGET.partner
    });
};
export var CustomPlansManagementRouting = function CustomPlansManagementRouting() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$areFeaturesLoade = _ref.areFeaturesLoaded, areFeaturesLoaded = _ref$areFeaturesLoade === void 0 ? false : _ref$areFeaturesLoade, _ref$isPackageProduct = _ref.isPackageProductSelectionEnabled, isPackageProductSelectionEnabled = _ref$isPackageProduct === void 0 ? false : _ref$isPackageProduct, _ref$isPlanProductSel = _ref.isPlanProductSelectionEnabled, isPlanProductSelectionEnabled = _ref$isPlanProductSel === void 0 ? false : _ref$isPlanProductSel, _ref$isPackagesListRe = _ref.isPackagesListRedesignEnabled, isPackagesListRedesignEnabled = _ref$isPackagesListRe === void 0 ? false : _ref$isPackagesListRe;
    // Full-page create/edit flows are gated by their own flags; until then the lists keep using the
    // legacy modal, so the routes must not exist.
    var showPackageForms = areFeaturesLoaded && isPackageProductSelectionEnabled;
    var shouldRenderPlanFormPage = areFeaturesLoaded && isPlanProductSelectionEnabled;
    /**
     * The redesigned list drops the legacy CustomPackageFormModal fallback, so its Create/Edit actions
     * only lead anywhere when the form routes exist. Requiring both flags keeps a lone flip from
     * shipping a list whose Edit action navigates nowhere.
     */
    var showRedesignedPackagesList = areFeaturesLoaded && isPackagesListRedesignEnabled && isPackageProductSelectionEnabled;
    /** Same bargain for plans: the redesigned list's Edit action needs the full-page edit route. */
    var showRedesignedPlansList = areFeaturesLoaded && isPackagesListRedesignEnabled && isPlanProductSelectionEnabled;
    return RouteGenerator(_objectSpread(_objectSpread({
        management: {
            path: CUSTOM_PLANS_MANAGEMENT_PATH,
            exact: true,
            component: CustomPlansManagement
        }
    }, shouldRenderPlanFormPage && {
        directPlanCreate: {
            path: DIRECT_PLAN_CREATE_PATH,
            component: DirectPlanForm,
            exact: true,
            permission: PermissionsEnum.ViewDirectPlansAndPackages
        },
        partnerPlanCreate: {
            path: PARTNER_PLAN_CREATE_PATH,
            component: PartnerPlanForm,
            exact: true,
            permission: PermissionsEnum.ViewPartnerPlansAndPackages
        },
        directPlanEdit: {
            path: DIRECT_PLAN_EDIT_PATH,
            component: DirectPlanForm,
            exact: true,
            permission: PermissionsEnum.ViewDirectPlansAndPackages
        },
        partnerPlanEdit: {
            path: PARTNER_PLAN_EDIT_PATH,
            component: PartnerPlanForm,
            exact: true,
            permission: PermissionsEnum.ViewPartnerPlansAndPackages
        }
    }), {}, {
        partnersPlansList: {
            path: PARTNER_PLANS_LIST_PATH,
            component: showRedesignedPlansList ? PartnerPlansListRedesigned : PartnerPlansList,
            exact: true,
            permission: PermissionsEnum.ViewPartnerPlansAndPackages
        },
        partnersPackagesList: {
            path: PARTNER_PACKAGES_LIST_PATH,
            component: showRedesignedPackagesList ? PartnerPackagesListRedesigned : PartnerPackagesList,
            exact: true,
            permission: PermissionsEnum.ViewPartnerPlansAndPackages
        },
        directPlansList: {
            path: PLANS_LIST_PATH,
            component: showRedesignedPlansList ? DirectPlansListRedesigned : CustomPlansList,
            exact: true,
            permission: PermissionsEnum.ViewDirectPlansAndPackages
        },
        directPackagesList: {
            path: PACKAGES_LIST_PATH,
            component: showRedesignedPackagesList ? DirectPackagesListRedesigned : CustomPackagesList,
            exact: true,
            permission: PermissionsEnum.ViewDirectPlansAndPackages
        }
    }, showPackageForms && {
        directPackageCreate: {
            path: PACKAGE_CREATE_PATH,
            component: DirectPackageCreateForm,
            exact: true,
            permission: PermissionsEnum.ViewDirectPlansAndPackages
        },
        partnerPackageCreate: {
            path: PARTNER_PACKAGE_CREATE_PATH,
            component: PartnerPackageCreateForm,
            exact: true,
            permission: PermissionsEnum.ViewPartnerPlansAndPackages
        },
        directPackageEdit: {
            path: PACKAGE_EDIT_PATH,
            component: DirectPackageEditForm,
            exact: true,
            permission: PermissionsEnum.ViewDirectPlansAndPackages
        },
        partnerPackageEdit: {
            path: PARTNER_PACKAGE_EDIT_PATH,
            component: PartnerPackageEditForm,
            exact: true,
            permission: PermissionsEnum.ViewPartnerPlansAndPackages
        }
    }));
};
